items:
  - "Manual Workflows"
  - "Compliance Overhead"
  - "Document Chaos"
  - "Onboarding Bottlenecks"
  - "Security Blind Spots"
  - "Contractor Sprawl"
  - "Pipeline Vulnerabilities"
  - "N8N Automations"

separator: " ◆ "
